import { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText, RefreshCw } from "lucide-react";
import { apiClient } from "@/integrations/sqlserver/client";

const DebugIndex = () => {
  const [reports, setReports] = useState([]);
  const [reportGroups, setReportGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log('Fetching data...');
        
        // Test API calls using API client
        const reportsData = await apiClient.get('/reports');
        console.log('Reports:', reportsData);
        
        const groupsData = await apiClient.get('/report-groups');
        console.log('Groups:', groupsData);
        
        setReports(reportsData.data || []);
        setReportGroups(groupsData.data || []);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-background p-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center py-20">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
            <p className="text-muted-foreground">Đang tải dữ liệu...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-background p-6">
        <div className="max-w-7xl mx-auto">
          <Card className="mt-20">
            <CardContent className="p-8 text-center">
              <p className="text-destructive mb-4">Lỗi: {error}</p>
              <Button onClick={() => window.location.reload()} variant="outline">
                <RefreshCw className="h-4 w-4 mr-2" />
                Thử lại
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-4xl font-bold mb-2">Debug: Hệ thống quản lý báo cáo</h1>
          <p className="text-xl text-muted-foreground">Testing data loading</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <FileText className="h-5 w-5" />
                Reports ({reports.length})
              </CardTitle>
            </CardHeader>
            <CardContent>
              {reports.length > 0 ? (
                <div>
                  <p className="text-green-600">✅ Data loaded successfully</p>
                  <p className="text-sm text-muted-foreground mt-2">
                    First report: {reports[0]?.ReportName || 'N/A'}
                  </p>
                </div>
              ) : (
                <p className="text-yellow-600">⚠️ No reports found</p>
              )}
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <FileText className="h-5 w-5" />
                Report Groups ({reportGroups.length})
              </CardTitle>
            </CardHeader>
            <CardContent>
              {reportGroups.length > 0 ? (
                <div>
                  <p className="text-green-600">✅ Data loaded successfully</p>
                  <p className="text-sm text-muted-foreground mt-2">
                    First group: {reportGroups[0]?.GroupName || 'N/A'}
                  </p>
                </div>
              ) : (
                <p className="text-yellow-600">⚠️ No report groups found</p>
              )}
            </CardContent>
          </Card>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Debug Info</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-2 text-sm">
              <p><strong>API Status:</strong> {error ? '❌ Error' : '✅ Working'}</p>
              <p><strong>Reports Count:</strong> {reports.length}</p>
              <p><strong>Groups Count:</strong> {reportGroups.length}</p>
              <p><strong>Loading State:</strong> {loading ? 'Loading...' : 'Complete'}</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default DebugIndex;
